var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  fill: "none",
  stroke: "currentcolor",
  color: "#726b7b",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.74 13.515c3.258 0 5.9-2.774 5.9-6.195 0-3.421-2.642-6.195-5.9-6.195-3.259 0-5.9 2.774-5.9 6.195 0 3.421 2.641 6.195 5.9 6.195Z",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "m12.576 11.038 4.13 4.13"
})));
export default SvgSearch;